import { useEffect } from "react";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Datenschutz() {
  useEffect(() => { document.title = "Datenschutz – Englputzeder Tippspiel"; }, []);

  return (
    <LegalLayout title="Datenschutzerklärung">
      <p className="text-muted-foreground">
        Der Schutz deiner personenbezogenen Daten ist uns wichtig. Wir verarbeiten deine Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003).
      </p>

      <LegalSection title="Verantwortlicher">
        <p className="text-foreground font-semibold">Englputzeder GmbH</p>
        <p>Furt 44, 4754 Andrichsfurt, Österreich</p>
        <p>E-Mail: <a href="mailto:anfrage@englputzeder.at" className="underline">anfrage@englputzeder.at</a> · Tel.: +43 7750-20194</p>
      </LegalSection>

      <LegalSection title="Welche Daten wir verarbeiten">
        <ul className="list-disc pl-5 space-y-1">
          <li><b>Account-Daten:</b> E-Mail-Adresse, Benutzername, Profilbild bzw. Emoji</li>
          <li><b>Authentifizierung:</b> Passwort (verschlüsselt) oder Magic-Link / Google-Login</li>
          <li><b>Tippspiel-Daten:</b> abgegebene Tipps, Bonus-Auswahl (z. B. WM-Sieger), erzielte Punkte, Gruppenzugehörigkeit</li>
          <li><b>Technische Daten:</b> IP-Adresse, Browser, Zeitstempel (Server-Logs)</li>
        </ul>
      </LegalSection>

      <LegalSection title="Rechtsgrundlagen">
        <p>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung — Teilnahme am Tippspiel)</p>
        <p>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung — z. B. bei optionalen Mitteilungen)</p>
        <p>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse — Sicherheit, Betrugsprävention)</p>
      </LegalSection>

      <LegalSection title="Auftragsverarbeiter & Hosting">
        <p>Backend, Datenbank, Authentifizierung und Hosting werden über Lovable Cloud bereitgestellt. Die Daten werden auf Servern innerhalb der EU verarbeitet. Mit dem Anbieter besteht ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO.</p>
      </LegalSection>

      <LegalSection title="Cookies & lokale Speicherung">
        <p>Wir verwenden technisch notwendige Cookies bzw. LocalStorage-Einträge zur Aufrechterhaltung deiner Anmeldung (Auth-Token) und zum Speichern deines Onboarding-Status. Es erfolgt kein Tracking durch Drittanbieter und kein Profiling zu Werbezwecken.</p>
      </LegalSection>

      <LegalSection title="Speicherdauer">
        <p>Account- und Tippdaten werden bis zum Ende des Tippspiels (FIFA WM 2026) zuzüglich 6 Monate für die Gewinnabwicklung gespeichert. Danach werden die Daten gelöscht oder anonymisiert. Du kannst deinen Account jederzeit löschen lassen (E-Mail an anfrage@englputzeder.at).</p>
      </LegalSection>

      <LegalSection title="Deine Rechte">
        <p>Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Wende dich dafür an <a href="mailto:anfrage@englputzeder.at" className="underline">anfrage@englputzeder.at</a>.</p>
        <p>
          Beschwerderecht bei der Aufsichtsbehörde:<br />
          <b className="text-foreground">Österreichische Datenschutzbehörde</b><br />
          Barichgasse 40-42, 1030 Wien<br />
          <a href="https://www.dsb.gv.at" target="_blank" rel="noopener noreferrer" className="underline">www.dsb.gv.at</a>
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
